var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditableInputWithIcon',{class:_vm.$style.editableInputContainer,attrs:{"attribute":"name","config":_vm.editableInputConfig,"handleSubmit":_vm.handleInputSubmit,"isEditableFunction":_vm.isNameEditable,"item":_vm.item}},[_c('span',{attrs:{"title":_vm.getItemName}},[_vm._v(" "+_vm._s(_vm.getItemName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }